import styled, { css } from "styled-components";


export const CategoryChipRoot = styled.button<{selected: boolean}>(
    ({selected}) => css`
        border: 1px solid #EAE8F5;
        border-radius: 23px;
        background-color: ${selected ? "#43398E" : "#FFE375" };
        color: ${selected ? "white" : "#43398E" }; ;
        font-weight: 600;
        min-height: 24px;
        padding: 0 15px;
        font-size: 9.5px;
        cursor: pointer;
        margin-bottom: 10px;
    `
)